import React, { useState } from "react";

/**
 * Factura de SALIDA (entrega) — versión centrada y limpia.
 * - Todo centrado
 * - Sin "Comprobante de entrega"
 * - Sin número de factura
 * - Sin comentarios ni firmas
 * - Logo al final con dirección y sitio web
 * * Mejoras:
 * - Formato de fecha español (DD/MM/YYYY).
 * - Manejo de error para el logo externo (más robusto para impresión).
 * - **Corrección de ancho fijo:** Se elimina w-[800px] para permitir el modo Ticket.**
 */

const SHOP_ADDRESS =
  "Plaza Ysaclar, C/ Eugenio Dechamps esq. Max Henriquez Ureña #42, Los Prados, Santo Domingo, Dominican Republic 10131";
const SHOP_SITE = "PROOMTB.COM";
const LOGO_SRC = "https://i.ibb.co/ymqv0Bhw/PROOMTB-PNG.jpg"; // Logo oficial

export function Factura({ bike = {} }) {
  // Estado para manejar si el logo externo falló en cargar
  const [imageError, setImageError] = useState(false);

  // Formato de fecha más claro (DD/MM/YYYY) para impresión en español
  const deliveryDate = bike?.deliveryDate ? new Date(bike.deliveryDate) : new Date();
  const formattedDate = deliveryDate.toLocaleDateString("es-DO", {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });

  const Row = ({ label, value }) =>
    value ? (
      <p className="text-sm leading-5"> {/* Se redujo el texto de base a sm para ticket */}
        <span className="font-semibold">{label}: </span>
        <span>{value}</span>
      </p>
    ) : null;

  return (
    <div
      // CAMBIO CLAVE: Se elimina el ancho fijo (w-[800px] y mx-auto) para que
      // la impresión de ticket (72mm) pueda tomar control.
      // Se añade la clase ticket-print-format para ajustes finos si es necesario.
      className="p-4 print-area ticket-print-format" 
      style={{ background: "#fff", color: "#000", textAlign: 'left' }} // Forzar alineación izquierda
    >
      {/* Encabezado simple: alineación a la izquierda */}
      <h2 className="text-lg font-bold mb-1">Datos de Entrega</h2> {/* Reducido para ticket */}
      {/* Usamos el formato de fecha mejorado */}
      <p className="text-xs mb-4">{formattedDate}</p>

      {/* Datos del cliente y bicicleta */}
      <div className="space-y-1 mb-4">
        <Row
          label="Cliente"
          value={[bike.clientName, bike.clientLastName].filter(Boolean).join(" ")}
        />
        <Row label="Teléfono" value={bike.phoneNumber} />
        <Row label="Correo" value={bike.email} />
        <Row label="Marca" value={bike.bikeBrand} />
        <Row label="Modelo" value={bike.bikeModel} />
        <Row label="Serie" value={bike.serialNumber} />
      </div>

      {/* Separador */}
      <div
        className="my-4"
        style={{ height: 1, width: "100%", background: "#000" }} // Ancho 100% para la línea
      />

      {/* Pie de página con Logo + dirección abajo (alineado a la izquierda) */}
      <div className="mt-4 text-xs" style={{ textAlign: 'center' }}> {/* Centrar solo el bloque del logo */}
        {imageError ? (
          // Mostrar texto alternativo si la imagen falla
          <p className="text-sm font-bold mb-3" style={{ height: 50, lineHeight: '50px' }}>
            [LOGO NO CARGADO]
          </p>
        ) : (
          // Mostrar imagen con manejo de error
          <img
            src={LOGO_SRC}
            alt="PROOMTB Logo"
            onError={() => setImageError(true)} // Captura el error de carga
            className="mx-auto" // Mantener centrado el logo
            style={{ height: 50, width: "auto" }} // Logo más pequeño para ticket
          />
        )}
        <div className="mt-2 text-xs leading-4" style={{ textAlign: 'center' }}>
          <p>{SHOP_ADDRESS}</p>
          <p className="font-semibold">{SHOP_SITE}</p>
        </div>
      </div>
    </div>
  );
}

export default Factura;
